function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @packageDocumentation
 * @internal
 */
import AsyncStorage from '@react-native-async-storage/async-storage';
export class LocalStorage {
  constructor(instanceName, apiKey) {
    _defineProperty(this, "namespace", void 0);

    _defineProperty(this, "map", {});

    const shortApiKey = apiKey.substring(apiKey.length - 6);
    this.namespace = `amp-exp-${instanceName}-${shortApiKey}`;
  }

  put(key, value) {
    this.map[key] = value;
  }

  get(key) {
    let value = this.map[key];

    if (value === undefined) {
      value = null;
    }

    return value;
  }

  clear() {
    this.map = {};
  }

  getAll() {
    return this.map;
  }

  async load() {
    try {
      const item = await AsyncStorage.getItem(this.namespace);
      const map = JSON.parse(item) || {};
      const newMap = {};

      for (const [key, value] of Object.entries(map)) {
        if (typeof value === 'string') {
          // old format
          newMap[key] = {
            value: value
          };
        } else if (typeof value === 'object') {
          // new format
          newMap[key] = {
            // @ts-ignore
            value: value.value,
            // @ts-ignore
            payload: value.payload
          };
        }
      }

      this.map = newMap;
    } catch (e) {
      this.map = {};
    }
  }

  async save() {
    try {
      await AsyncStorage.setItem(this.namespace, JSON.stringify(this.map));
    } catch (e) {// pass
    }
  }

}
//# sourceMappingURL=localStorage.js.map